export const COMPANY = {
  name: "Fitzgerald Earthworks Ltd",
  shortName: "Fitzgerald",
  phone: "021 678 720",
  phoneHref: "tel:+64211678720",
  email: "accounts@fitzgeraldearthworks.co.nz",
  emailHref: "mailto:accounts@fitzgeraldearthworks.co.nz",
  location: "Mangatangi, Waikato",
  region: "Waikato, Auckland & Hauraki",
  experience: "20+ Years",
  established: "Family-owned & operated",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Projects", to: "/projects" },
  { label: "Equipment", to: "/equipment" },
  { label: "Testimonials", to: "/testimonials" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    slug: "site-cuts",
    title: "Site Cuts & Building Platforms",
    summary:
      "Precision cut-and-fill, level platforms and engineered house pads built to your plans and council specs.",
    bullets: [
      "Residential & light-commercial pads",
      "Cut-to-fill balance & compaction",
      "Survey marks & finished levels",
    ],
  },
  {
    slug: "farm-tracks",
    title: "Farm Track Construction",
    summary:
      "Durable, well-drained farm races and laneways that hold up to stock, tractors and Waikato weather.",
    bullets: [
      "All-weather farm races",
      "Crowned tracks with side drains",
      "Race upgrades & widening",
    ],
  },
  {
    slug: "drainage",
    title: "Drainage & Trenching",
    summary:
      "Subsoil and surface drainage, novaflo, culverts and trenching to keep water moving where it should.",
    bullets: [
      "Novaflo & subsoil drains",
      "Open drains & culverts",
      "Trenching for services",
    ],
  },
  {
    slug: "driveways",
    title: "Driveways & Accessways",
    summary:
      "Rural driveways and accessways shaped, sealed and compacted for long-term performance.",
    bullets: [
      "Rural & lifestyle driveways",
      "Metal supply & laying",
      "Entranceways & culverts",
    ],
  },
  {
    slug: "land-clearing",
    title: "Land Clearing",
    summary:
      "Scrub, stump and vegetation clearing to ready blocks for development, grazing or planting. We can trim down thick bush and take out smaller trees as needed.",
    bullets: [
      "Scrub, gorse & thick bush clearing",
      "Tree trimming & smaller tree removal",
      "Stump & root removal",
      "Tidy site finish",
    ],
  },
  {
    slug: "excavation",
    title: "Excavation & Earthmoving",
    summary:
      "From foundation digs to bulk earthworks, we handle the shifting, shaping and shaping again.",
    bullets: [
      "Foundations & footings",
      "Bulk earthmoving",
      "Retaining wall prep",
    ],
  },
  {
    slug: "ponds-dams",
    title: "Pond & Dam Construction",
    summary:
      "Stock water ponds, effluent ponds and dams formed and shaped with a focus on holding capacity.",
    bullets: [
      "Stock & irrigation ponds",
      "Effluent pond construction",
      "Dam shaping & repair",
    ],
  },
  {
    slug: "trucking",
    title: "Trucking & Material Cartage",
    summary:
      "Tip truck cartage for metal, topsoil, sand and fill — supply and removal, on time.",
    bullets: [
      "Metal, sand & topsoil supply",
      "Site spoil removal",
      "Local & regional cartage",
    ],
  },
  {
    slug: "rural",
    title: "Rural & Agricultural Earthworks",
    summary:
      "Practical solutions for farms — yards, troughs, fencing prep, culverts and everything in between.",
    bullets: [
      "Yards, troughs, races",
      "Culvert install & repair",
      "Fence line prep",
    ],
  },
  {
    slug: "tractor-spreading",
    title: "Tractor Work & Spreading",
    summary:
      "Tractor with scoop and spreader available for chicken manure spreading, fertiliser, lime and general farm tractor work.",
    bullets: [
      "Chicken manure spreading",
      "Lime & fertiliser spreading",
      "General tractor & scoop work",
    ],
  },
];

export const EQUIPMENT = [
  {
    name: "20-Tonne Excavator",
    role: "Bulk earthworks & deep digs",
    detail:
      "Workhorse for site cuts, pond construction and any project that calls for serious reach and bucket capacity.",
  },
  {
    name: "13-Tonne Excavator",
    role: "Versatile mid-size digger",
    detail:
      "The go-to machine for drainage, building platforms, farm tracks and most rural jobs.",
  },
  {
    name: "5-Tonne Excavator",
    role: "Tight access & finish work",
    detail:
      "Compact and nimble for trenching, residential sections and confined-access work.",
  },
  {
    name: "Bulldozer",
    role: "Shaping, spreading & track work",
    detail:
      "Ideal for spreading fill, shaping farm tracks and forming pond batters.",
  },
  {
    name: "6-Wheeler Tipper Truck",
    role: "Cartage & material supply",
    detail:
      "Metal, topsoil, sand and fill — supplied to site or hauled away when the job calls for it.",
  },
  {
    name: "8-Wheeler Transporter",
    role: "Machine & heavy load transport",
    detail:
      "Shifting the diggers, dozer and heavier gear between sites across the Waikato, Auckland and Hauraki.",
  },
  {
    name: "Tractor, Scoop & Spreader",
    role: "Spreading, levelling & farm work",
    detail:
      "Tractor with scoop and spreader available for chicken manure spreading, fertiliser, lime, light earthworks and a range of agricultural tasks.",
  },
  {
    name: "Uni Control GPS System",
    role: "Millimetre-accurate work",
    detail:
      "GPS-guided machine control for precise levels, batters and grades — saves time on site and gets the finished surface right first time.",
  },
  {
    name: "Tandem Tipping Trailer",
    role: "Local cartage support",
    detail:
      "Handy for smaller cartage runs and shifting materials around larger sites.",
  },
  {
    name: "Compaction Roller",
    role: "Platform & track compaction",
    detail:
      "Used to lock in compacted layers on building platforms, driveways and tracks.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Hayden M.",
    role: "Dairy Farmer, Waikato",
    quote:
      "Fitzgerald put in a new race for us through some wet country and it's still holding up beautifully two winters later. Solid blokes, honest pricing, no mucking around.",
  },
  {
    name: "Sarah & Tim R.",
    role: "Lifestyle Block Owners, Mangatangi",
    quote:
      "From the driveway to the house platform, everything was done exactly how it was quoted. Tidy site, clear communication, finished ahead of schedule.",
  },
  {
    name: "Greg P.",
    role: "Drystock Farmer, Auckland",
    quote:
      "Got a couple of stock water ponds dug and a fair bit of subsoil drainage done. Top quality workmanship — exactly what you want from a rural contractor.",
  },
  {
    name: "Megan K.",
    role: "Builder, Pukekohe",
    quote:
      "We use Fitzgerald for our site cuts whenever they're available. Levels are spot on, they leave a clean platform, and they understand the build timeline.",
  },
];

export const PROJECT_CATEGORIES = [
  "All",
  "Site Cuts",
  "Drainage",
  "Farm Tracks",
  "Ponds & Dams",
  "Driveways",
  "Land Clearing",
  "Trucking",
];

export const PROJECTS = [
  {
    title: "Concrete Bunker & Farm Trench Work",
    location: "Waikato",
    category: "Drainage",
    description: "Trench excavation and concrete bunker wall installation on a working dairy farm.",
    image: "https://customer-assets.emergentagent.com/job_fitzgerald-earth/artifacts/f3o0y4w0_imagejpeg_2%20%286%29.JPG",
  },
  {
    title: "Effluent Pond Lining",
    location: "Hauraki",
    category: "Ponds & Dams",
    description: "Effluent pond formed and shaped with liner installation by the crew.",
    image: "https://customer-assets.emergentagent.com/job_fitzgerald-earth/artifacts/w31kw0xe_imagejpeg_2%20%284%29.JPG",
  },
  {
    title: "Bulk Site Cut & Levelling",
    location: "Waikato",
    category: "Site Cuts",
    description: "Large-scale site cut with finished platform shaped and rolled ready for build.",
    image: "https://customer-assets.emergentagent.com/job_fitzgerald-earth/artifacts/ehb60c6d_imagejpeg_2%20%285%29.JPG",
  },
  {
    title: "Bush & Tree Clearing",
    location: "Waikato",
    category: "Land Clearing",
    description: "Trimming thick bush and removing smaller trees along a rural fence line.",
    image: "https://customer-assets.emergentagent.com/job_fitzgerald-earth/artifacts/txqe6612_image.png",
  },
  {
    title: "Night Cartage Run",
    location: "Waikato / Hauraki",
    category: "Trucking",
    description: "Truck and trailer loaded up for a night cartage run between sites.",
    image: "https://customer-assets.emergentagent.com/job_fitzgerald-earth/artifacts/tpi962ax_imagejpeg_2%20%283%29.JPG",
  },
  {
    title: "Residential House Platform",
    location: "Mangatangi",
    category: "Site Cuts",
    description: "Full cut-and-fill platform with engineered compaction to suit timber-framed home.",
  },
  {
    title: "Subsoil Drainage Upgrade",
    location: "Waikato",
    category: "Drainage",
    description: "1.2km of novaflo drainage installed across a 40ha dairy block.",
  },
  {
    title: "All-Weather Farm Race",
    location: "Pukekohe",
    category: "Farm Tracks",
    description: "Crowned race with side drains and metal cap, built to handle daily stock movement.",
  },
  {
    title: "Stock Water Pond",
    location: "Auckland Rural",
    category: "Ponds & Dams",
    description: "Excavation and shaping of a 1.5ML stock water pond with batters and inlet.",
  },
  {
    title: "Rural Driveway",
    location: "Mangatangi",
    category: "Driveways",
    description: "300m driveway with culvert entrance, shaped, metalled and rolled.",
  },
];
